import React from "react";
import { useSearchParams } from "react-router-dom";
import CustomTabPanel from "components/Shared/CustomTabPanel";
import CustomTabs from "components/Shared/CustomTabs";
import RowsSkeleton from "components/Shared/Skeleton/RowsSkeleton";
import { useGetNotesBySourceQuery } from "store/services/noteApi";
import { useGetDocumentsBySourceQuery } from "store/services/documentApi";
import NoteTab from "../../Note/Notetab";
import DocumentsTab from "../../Document/DocumentTab";
import { useLocalTransportDetailContext } from "contexts/LocalTransportDetailContext";
import LocalTransportShipmentList from "./LocalTransportShipmentList";

const LocalTransportDetailTab = () => {
  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get("tab") || "note";
  const { localTransportDetail } = useLocalTransportDetailContext();

  const { data: notes } = useGetNotesBySourceQuery(
    { source: "LocalTransport", sourceRef: localTransportDetail?._id },
    { skip: !localTransportDetail?._id }
  );

  const { data: documents } = useGetDocumentsBySourceQuery(
    { source: "LocalTransport", sourceRef: localTransportDetail?._id },
    { skip: !localTransportDetail?._id }
  );

  const tabs = [
    { label: "Note", value: "note", badgeCount: notes?.length || 0 },
    { label: "Document", value: "document", badgeCount: documents?.totalItems },
    { label: "Shipment", value: "shipment",  }
  ];

  return (
    <>
      <CustomTabs tabs={tabs} activeTab={activeTab} />
      {localTransportDetail ? (
        <>
          <CustomTabPanel activeTab={activeTab} value="note">
            <NoteTab
              source="LocalTransport"
              sourceRef={localTransportDetail._id}
            />
          </CustomTabPanel>
          <CustomTabPanel activeTab={activeTab} value="document">
            <DocumentsTab
              source="LocalTransport"
              sourceRef={localTransportDetail._id}
            />
          </CustomTabPanel>

          <CustomTabPanel activeTab={activeTab} value="shipment">
                    <LocalTransportShipmentList/>
                    </CustomTabPanel>
        </>
      ) : (
        <RowsSkeleton />
      )}
    </>
  );
};

export default LocalTransportDetailTab;
